import { HStack } from '@chakra-ui/react';
import React from 'react';

import type { TabsValueChangeDetails } from 'node_modules/@chakra-ui/react/dist/types/components/tabs/tabs';
import type { TokenType } from 'types/api/token';

import type { SelectOption } from 'toolkit/chakra/select';
import type { TokenTypeFiltersProps } from 'ui/token/TokenTypeFilters';
import TokenTypeFilters from 'ui/token/TokenTypeFilters';

import { TabsSelect } from '../filters/TabsSelect';

const options: Array<SelectOption> = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'from',
    label: 'Outgoing',
  },
  {
    value: 'to',
    label: 'Incoming',
  },
];

interface Props extends TokenTypeFiltersProps<TokenType> {
  onAddressFilterChange: (detail: TabsValueChangeDetails) => void;
  onRemoveTypeFilter: (nextValue: TokenType) => void;
}

const TokenTransferFilter = ({
  onAddressFilterChange,
  onRemoveTypeFilter,
  defaultAddressFilter,
  onTypeFilterChange,
  selectedValues: defaultTypeFilters,
  isLoading,
}: Props) => {

  return (
    <HStack gap={ 3 }>
      <TabsSelect
        collection={ options }
        onChange={ onAddressFilterChange }
        initialValue={ defaultAddressFilter }
      />
      <TokenTypeFilters
        onTypeFilterChange={ onTypeFilterChange }
        onRemoveTypeFilter={ onRemoveTypeFilter }
        selectedValues={ defaultTypeFilters }
        isLoading={ isLoading }
      />
    </HStack>
  );
};

export default React.memo(TokenTransferFilter);
